import { render, staticRenderFns } from "./EditGroupBuySetting.vue?vue&type=template&id=33606190"
import script from "./EditGroupBuySetting.vue?vue&type=script&lang=js"
export * from "./EditGroupBuySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports